"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseMenuItems = exports.TOP_LEVEL = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _MenuItem = _interopRequireDefault(require("./MenuItem"));
var _utils = require("../utils");
var _SubMenu = _interopRequireDefault(require("./SubMenu"));
var _index = require("./index");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// MenuItem的顶层层级
var TOP_LEVEL = exports.TOP_LEVEL = 0;
var parseMenuItems = exports.parseMenuItems = function parseMenuItems(_children) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TOP_LEVEL;
  var keySet = new Set();
  var parseChild = function parseChild(child, _level, index) {
    if ( /*#__PURE__*/_react.default.isValidElement(child)) {
      var key = child.key,
        props = child.props,
        type = child.type;
      // 只处理MenuItem、SubMenu、MenuItemGroup类型的组件，其他类型组件将被忽略
      if (![_MenuItem.default, _SubMenu.default, _index.MenuItemGroup].includes(type)) {
        return null;
      }
      if (!key) {
        console.error('警告：Menu的每个子节点都应该设置唯一的key属性，虽然会自动为你分配一个，但可能会有潜在的问题:', child);
      } else if (keySet.has(key)) {
        console.error("Menu\u7EC4\u4EF6\u7684\u5B50\u8282\u70B9key\u5C5E\u6027\u503C\u91CD\u590D\uFF1A '".concat(key, "'."), child);
      } else {
        keySet.add(key);
      }
      // 兜底的key，当用户未设置时启用
      var safeKey = key || "menu-item-".concat(_level, "-").concat(index);
      var restProps = (0, _utils.dropProps)(props, ['children']);
      if (type === _MenuItem.default) {
        return {
          content: props.children,
          key: safeKey,
          // @ts-ignore
          props: _objectSpread({}, restProps),
          children: [],
          level: _level,
          nodeType: 'MenuItem'
        };
      }
      if (type === _SubMenu.default) {
        return {
          content: props.label,
          key: safeKey,
          // @ts-ignore
          props: _objectSpread({}, restProps),
          children: parseMenuItems(props.children, _level + 1),
          level: _level,
          nodeType: 'SubMenu'
        };
      }
      if (type === _index.MenuItemGroup) {
        return {
          content: props.label,
          key: safeKey,
          // @ts-ignore
          props: _objectSpread({}, restProps),
          children: parseMenuItems(props.children, _level),
          level: _level,
          nodeType: 'MenuItemGroup'
        };
      }
    }
    return null;
  };
  // TODO: 还不支持Fragment
  var parsedItems = _react.default.Children.map(_children, function (child, ind) {
    if ( /*#__PURE__*/_react.default.isValidElement(child) && child.type === _react.default.Fragment) {
      return _react.default.Children.map(child.props.children, function (fragmentChild, i) {
        return parseChild(fragmentChild, level, i);
      });
    }
    // @ts-ignore
    return parseChild(child, level, ind);
  });
  return (parsedItems !== null && parsedItems !== void 0 ? parsedItems : []).filter(Boolean);
};